import { setThemingIsEnabled } from 'owa-acui';

/** Used when Fluent v8 is used */
let appThemeInitialized = false;

/**
 * Loads the `AppTheme` used by ACUI components in order to properly output the light or dark theme.
 *
 * This is the old approach used before 1JS's Fluent UI v9 integation and can be removed when the
 * `mon-ribbon-fluent-v9-ribbon` flight graduates.
 *
 * This is intended to be called:
 * 1. Before the first render (so not inside of an `useEffect`)
 * 2. Inside a component function (so that it doesn't get called unless we actually render that component)
 */
export function ensureAppThemeInitialized(): void {
    if (!appThemeInitialized) {
        setThemingIsEnabled(true);
        appThemeInitialized = true;
    }
}
